import React, { useEffect, useState } from "react";
import Datas from "../data/footer/footer2.json";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import BackToTop from "./common/BackToTop";
import { Styles } from "./styles/footerTwo.js";
import { BLOGS_ENDPOINT } from "../config/api";

function FooterTwo() {
  const [latestBlogs, setLatestBlogs] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchLatestBlogs = async () => {
      try {
        const response = await fetch(`${BLOGS_ENDPOINT}?limit=10`, {
          signal: controller.signal,
        });
        const payload = await response.json();
        const blogs = Array.isArray(payload.blogs) ? payload.blogs : [];

        const published = blogs
          .filter((b) => b.status === "published")
          .sort(
            (a, b) =>
              new Date(b.publishedAt).getTime() -
              new Date(a.publishedAt).getTime()
          )
          .slice(0, 3);

        setLatestBlogs(published);
      } catch (err) {
        console.error("Footer blogs fetch error:", err);
        setLatestBlogs([]);
      }
    };
    fetchLatestBlogs();
    return () => controller.abort();
  }, []);

  useEffect(() => {
    const form = document.getElementById("form4");
    const email = document.getElementById("email4");

    form.addEventListener("submit", formSubmit);

    function formSubmit(e) {
      e.preventDefault();

      const emailValue = email.value.trim();

      if (emailValue === "") {
        setError(email, "Email can't be blank");
      } else if (!isEmail(emailValue)) {
        setError(email, "Not a valid email");
      } else {
        setSuccess(email);
      }
    }

    function setError(input, message) {
      const formControl = input.parentElement;
      const errorMsg = formControl.querySelector(".input-msg4");
      formControl.className = "form-control error";
      errorMsg.innerText = message;
    }

    function setSuccess(input) {
      const formControl = input.parentElement;
      formControl.className = "form-control success";
    }

    function isEmail(email) {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
    }
  });

  return (
    <Styles>
      {/* Footer Two */}
      <footer
        className="footer2"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${Datas.backgroundImage})`,
        }}
      >
        <Container>
          <Row>
            <Col md="3">
              <div className="footer-logo-info">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo/logo2.png"}
                  alt="Swiss School"
                  className="img-fluid"
                />
                <p>
                  Swiss School supports students worldwide with tailored
                  counselling, curated courses, and transparent application
                  guidance.
                </p>
                <ul className="list-unstyled">
                  <li>
                    <i className="las la-map-marker"></i>Topaz Building,
                    Panjagutta, Hyderabad - 500 082
                  </li>
                  <li>
                    <i className="las la-envelope"></i>contact@swissschools.in
                  </li>
                  <li>
                    <i className="las la-phone"></i> +91 90523 78789
                  </li>
                </ul>
              </div>
            </Col>
            <Col md="3">
              <div className="f-links">
                <h5>Quick Links</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/about"}>
                      <i className="las la-angle-right"></i>About Swiss School
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/courses"}>
                      <i className="las la-angle-right"></i>Find Courses
                    </Link>
                  </li>
                  {/* <li>
                    <Link to={process.env.PUBLIC_URL + "/instructor"}>
                      <i className="las la-angle-right"></i>Meet Our Instructors
                    </Link>
                  </li> */}
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/events"}>
                      <i className="las la-angle-right"></i>Upcoming Events
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/contact"}>
                      <i className="las la-angle-right"></i>Contact & Support
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col md="3">
              <div className="f-post">
                <h5>Latest Updates</h5>
                {latestBlogs.length > 0 ? (
                  latestBlogs.map((blog) => {
                    const date = blog.publishedAt
                      ? new Date(blog.publishedAt).toLocaleDateString()
                      : "";
                    const slugPath = `/blog-details${
                      blog.slug ? `?slug=${encodeURIComponent(blog.slug)}` : ""
                    }`;
                    return (
                      <div className="post-box d-flex" key={blog._id}>
                        <div className="po-icon">
                          <i className="fab fa-twitter"></i>
                        </div>
                        <div className="po-content">
                          <Link to={process.env.PUBLIC_URL + slugPath}>
                            {blog.title}
                          </Link>
                          <span>{date}</span>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No recent posts available.</p>
                )}
              </div>
            </Col>

            <Col md="3">
              <div className="f-newsletter">
                <h5>Newsletter</h5>
                <p>
                  Subscribe for curated study abroad tips and program
                  announcements.
                </p>

                <form id="form4" className="form">
                  <p className="form-control">
                    <input
                      type="email"
                      placeholder="Enter email here"
                      id="email4"
                    />
                    <span className="input-msg4"></span>
                  </p>
                  <button>Submit</button>
                </form>
              </div>
            </Col>
            <Col md="12">
              <div className="copytext-area text-center">
                <p>
                  Copyright &copy; {new Date().getFullYear()} | Swiss School.
                  All rights reserved.
                </p>
                <span className="footer-contact">
                  Need help? Email{" "}
                  <a href="mailto:contact@swissschools.in">
                    contact@swissschools.in
                  </a>
                </span>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Back To Top  */}
        <BackToTop />
      </footer>
    </Styles>
  );
}

export default FooterTwo;
